// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PhotoBook designer — calm, light visual layer.
   Loaded AFTER PhotoBookDesigner.css / PagesManager.css so it only restyles
   (colours, spacing, radii, typography). Layout/behaviour rules there are
   untouched; anything that would clash with their mobile-drawer rules is
   scoped to min-width: 1101px. */

.photobook-designer {
  --pb-bg: #f6f7f9;
  --pb-surface: #ffffff;
  --pb-line: #e6e8ec;
  --pb-line-strong: #d3d7de;
  --pb-ink: #1f2937;
  --pb-ink-soft: #6b7280;
  --pb-ink-faint: #9aa1ad;
  --pb-accent: #1f2937;
  --pb-focus: #4f6bed;
  --pb-danger: #c0392b;
  --pb-radius: 12px;
  --pb-radius-sm: 8px;
  --pb-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  background: var(--pb-bg);
  color: var(--pb-ink);
}

.photobook-designer button { font-family: inherit; }
.photobook-designer button:focus-visible,
.photobook-designer input:focus-visible,
.photobook-designer select:focus-visible {
  outline: 2px solid var(--pb-focus);
  outline-offset: 2px;
}

/* ───────── Sidebar (left) ───────── */
.designer-container { gap: 24px; }

.designer-sidebar { gap: 14px; width: 260px; }

.designer-product-info {
  background: var(--pb-surface);
  color: var(--pb-ink);
  border: 1px solid var(--pb-line);
  border-radius: var(--pb-radius);
  box-shadow: var(--pb-shadow);
  padding: 18px 20px;
  text-align: left;
}
.designer-product-info h2 {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--pb-ink);
}
.designer-product-price {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--pb-ink);
}

/* Page limits + counters → one quiet card */
.page-info-box {
  background: var(--pb-surface);
  border: 1px solid var(--pb-line);
  border-radius: var(--pb-radius);
  box-shadow: var(--pb-shadow);
  padding: 14px 16px 12px;
  align-items: flex-start;
  text-align: left;
}
.page-info-box h4 {
  margin: 0 0 6px;
  color: var(--pb-ink-faint);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.page-info-box p {
  margin: 2px 0;
  color: var(--pb-ink-soft);
  font-size: 13px;
}
.page-info-box .max-pages {
  color: var(--pb-ink);
  font-weight: 500;
}

.design-stats {
  gap: 0;
  background: var(--pb-surface);
  border: 1px solid var(--pb-line);
  border-radius: var(--pb-radius);
  box-shadow: var(--pb-shadow);
  overflow: hidden;
}
.stat {
  background: none;
  border-radius: 0;
  padding: 12px 6px;
  min-width: 0;
}
.stat + .stat { border-left: 1px solid var(--pb-line); }
.stat-value {
  font-size: 20px;
  font-weight: 600;
  color: var(--pb-ink);
  letter-spacing: -0.02em;
}
.stat-label {
  font-size: 10px;
  color: var(--pb-ink-faint);
  letter-spacing: 0.04em;
  margin-top: 3px;
  line-height: 1.25;
}

/* Actions */
.export-section {
  background: none;
  border: none;
  padding: 0;
  gap: 8px;
}
.proceed-btn,
.preview-toggle-btn {
  padding: 12px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: var(--pb-radius-sm);
  letter-spacing: 0;
}
.proceed-btn {
  background: var(--pb-accent);
  color: #fff;
  box-shadow: none;
}
.proceed-btn:hover:not(:disabled) {
  transform: none;
  background: #111827;
  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.18);
}
.proceed-btn:disabled {
  background: #cfd4dc;
  color: #fff;
  opacity: 1;
}
.preview-toggle-btn {
  background: var(--pb-surface);
  color: var(--pb-ink);
  border: 1px solid var(--pb-line-strong);
}
.preview-toggle-btn:hover:not(:disabled) {
  background: #f3f4f6;
  color: var(--pb-ink);
}
.preview-toggle-btn:disabled { opacity: 0.55; }

.min-photos-warning {
  background: none;
  border: none;
  color: var(--pb-ink-soft);
  font-size: 12px;
  padding: 0 2px;
  margin: 2px 0 0;
  text-align: left;
}

.help-info {
  background: none;
  border: none;
  border-top: 1px solid var(--pb-line);
  border-radius: 0;
  padding: 14px 2px 0;
}
.help-info h4 {
  color: var(--pb-ink-faint);
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.help-info ul { padding-left: 16px; color: var(--pb-ink-soft); font-size: 12px; line-height: 1.6; }
.help-info li { margin-bottom: 3px; }

/* ───────── Workspace ───────── */
.pages-manager {
  background: transparent;
  gap: 20px;
  max-height: none;
}

.pages-secondary-panel { padding: 0; gap: 12px; }

/* Background colours */
.page-bg-colors {
  background: var(--pb-surface);
  border: 1px solid var(--pb-line);
  border-radius: var(--pb-radius);
  box-shadow: var(--pb-shadow);
  padding: 10px 14px;
  gap: 8px;
}
.page-bg-colors span {
  color: var(--pb-ink-soft);
  font-size: 12px;
  font-weight: 500;
  margin-right: auto;
}
.page-color-btn {
  width: 22px;
  height: 22px;
  border: 1px solid var(--pb-line-strong);
}
.page-color-btn:hover { transform: none; border-color: var(--pb-ink-faint); }
.page-color-btn.active {
  border-color: var(--pb-ink);
  box-shadow: 0 0 0 2px #fff, 0 0 0 3px var(--pb-ink);
}

/* Photo library */
.library-header {
  gap: 8px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--pb-line);
}
.library-header h4 {
  color: var(--pb-ink);
  font-size: 13px;
  font-weight: 600;
}
.photo-count-badge {
  background: #eef0f4;
  color: var(--pb-ink-soft);
  font-weight: 600;
}
.add-photos-btn,
.add-photos-phone-btn,
.ai-generate-btn {
  padding: 10px 14px;
  border-radius: var(--pb-radius-sm);
  font-size: 13px;
  font-weight: 600;
  box-shadow: none;
}
.add-photos-btn { background: var(--pb-accent); }
.add-photos-btn:hover { background: #111827; box-shadow: none; }
.add-photos-phone-btn {
  color: var(--pb-ink);
  border: 1px solid var(--pb-line-strong);
}
.add-photos-phone-btn:hover:not(:disabled) {
  background: #f3f4f6;
  border-color: var(--pb-line-strong);
}
.ai-generate-btn {
  background: #eef1ff;
  color: #3b4bb8;
  border: 1px solid #d9defa;
}
.ai-generate-btn:hover:not(:disabled) {
  transform: none;
  box-shadow: none;
  background: #e4e9ff;
}
.mesazhi-per-foto {
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: var(--pb-ink-soft);
}
.mesazhi-per-foto strong { color: var(--pb-ink); font-weight: 600; }

.library-photos {
  gap: 8px;
  padding: 2px;
}
.library-photo { border-radius: 6px; overflow: hidden; background: #eef0f4; }
.library-photo-delete {
  top: 4px;
  right: 4px;
  background: rgba(17, 24, 39, 0.6);
  backdrop-filter: blur(4px);
}
.library-photo-delete:hover { background: var(--pb-danger); }

@media (min-width: 1101px) {
  .photo-library {
    background: var(--pb-surface);
    border: 1px solid var(--pb-line);
    border-radius: var(--pb-radius);
    box-shadow: var(--pb-shadow);
    padding: 16px;
    /* stop it stretching to the full row height when it has few photos */
    height: auto;
    max-height: 70vh;
  }
}

/* Canvas area */
.pages-main {
  background: transparent;
  padding: 0;
  gap: 14px;
}
.current-page-container {
  background: var(--pb-surface);
  border: 1px solid var(--pb-line);
  border-radius: var(--pb-radius);
  box-shadow: var(--pb-shadow);
}
.page-spread { box-shadow: 0 10px 30px rgba(16, 24, 40, 0.14); }
.page-editor { box-shadow: 0 6px 22px rgba(16, 24, 40, 0.12); }

/* Empty photo slot — quiet outline with a "+" instead of a camera emoji */
.photo-slot {
  background: #f4f5f8;
  border: 1.5px dashed var(--pb-line-strong);
  border-radius: 3px;
}
.photo-slot:not(.has-image):hover,
.photo-slot.drag-over {
  background: #eceef3;
  border-color: var(--pb-ink-faint);
}
.slot-placeholder { color: var(--pb-ink-faint); gap: 4px; }
.slot-icon { opacity: 0.9; }
.slot-text { font-size: 11px; font-weight: 500; color: var(--pb-ink-faint); }

.page-dimensions {
  background: rgba(17, 24, 39, 0.55);
  font-weight: 500;
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 999px;
  backdrop-filter: blur(4px);
}

/* Toolbar */
.pages-toolbar {
  background: var(--pb-surface);
  border: 1px solid var(--pb-line);
  border-radius: var(--pb-radius);
  box-shadow: var(--pb-shadow);
  padding: 8px;
  gap: 6px;
  flex-wrap: wrap;
}
.toolbar-action {
  background: transparent;
  border: 1px solid transparent;
  color: var(--pb-ink);
  padding: 9px 14px;
  border-radius: var(--pb-radius-sm);
  font-size: 13px;
  font-weight: 500;
}
.toolbar-action:hover { background: #f3f4f6; border-color: transparent; }
.toolbar-action.danger { color: var(--pb-danger); border-color: transparent; margin-left: auto; }
.toolbar-action.danger:hover { background: #fdf0ee; border-color: transparent; }

/* Thumbnail strip — light, not a heavy dark bar */
.pages-thumbnails {
  background: var(--pb-surface);
  border: 1px solid var(--pb-line);
  border-radius: var(--pb-radius);
  box-shadow: var(--pb-shadow);
  padding: 14px;
  gap: 12px;
}
.pages-thumbnails::-webkit-scrollbar-track { background: #f3f4f6; }
.pages-thumbnails::-webkit-scrollbar-thumb { background: #cfd4dc; }
.pages-thumbnails::-webkit-scrollbar-thumb:hover { background: var(--pb-ink-faint); }
.page-thumbnail:hover { transform: none; }
.thumbnail-preview {
  background: #fff;
  box-shadow: 0 0 0 1px var(--pb-line), 0 1px 3px rgba(16, 24, 40, 0.08);
}
.thumbnail-slot { background: #dfe2e8; }
.thumbnail-label { color: var(--pb-ink-faint); font-size: 11px; margin-top: 6px; }
.page-thumbnail.active .thumbnail-preview,
.page-thumbnail.active .thumbnail-preview.cover-thumbnail-preview {
  outline: 2px solid var(--pb-ink);
  outline-offset: 2px;
}
.page-thumbnail.active .thumbnail-label { color: var(--pb-ink); font-weight: 600; }
.add-page-thumbnail {
  background: #fafbfc;
  border: 1.5px dashed var(--pb-line-strong);
}
.add-page-thumbnail:hover { background: #f3f4f6; border-color: var(--pb-ink-faint); }
.add-page-thumbnail span { color: var(--pb-ink-faint); font-weight: 300; }

/* Layout picker */
.layout-picker {
  border: 1px solid var(--pb-line);
  border-radius: var(--pb-radius);
  box-shadow: var(--pb-shadow);
}
.layout-option { background: #fafbfc; border: 1px solid var(--pb-line); border-radius: var(--pb-radius-sm); }
.layout-option:hover { background: #f3f4f6; border-color: var(--pb-line-strong); }
.layout-option.active { background: var(--pb-ink); border-color: var(--pb-ink); }

/* Text panel */
.text-panel-vertical { background: var(--pb-ink); border-radius: var(--pb-radius-sm); box-shadow: none; }
.text-panel-btn.active { background: #4f6bed; border-color: #4f6bed; }
.text-panel-btn-apply { background: #3b4bb8; }
.text-panel-btn-apply:hover { background: #2f3d99; }

/* ───────── Tablet / mobile ───────── */
@media (max-width: 1100px) {
  .designer-container { gap: 8px; padding: 10px; }
  .designer-sidebar { width: auto; }

  .drawer-toggle-tab {
    background: var(--pb-surface);
    color: var(--pb-ink);
    border: 1px solid var(--pb-line-strong);
    border-radius: 999px;
    padding: 8px 14px;
    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.12);
  }
  .drawer-toggle-arrow { font-size: 14px; }
  .drawer-toggle-label { font-size: 12px; font-weight: 600; }

  .mobile-drawer { background: var(--pb-bg); }
  .mobile-drawer-header {
    background: var(--pb-surface);
    color: var(--pb-ink);
    border-bottom: 1px solid var(--pb-line);
    align-items: center;
  }
  .mobile-drawer-header h3 { font-size: 15px; font-weight: 600; margin: 0 0 2px; }
  .mobile-drawer-price { font-size: 16px; font-weight: 600; color: var(--pb-ink-soft); }
  .mobile-drawer-close {
    background: #f3f4f6;
    color: var(--pb-ink);
    width: 36px;
    height: 36px;
  }
  .mobile-drawer-body { padding: 14px; gap: 12px; }
  .mobile-drawer-body .photo-library {
    background: var(--pb-surface);
    border: 1px solid var(--pb-line);
    border-radius: var(--pb-radius);
    padding: 14px;
  }

  /* bottom action bar */
  .export-section {
    background: rgba(255, 255, 255, 0.96);
    backdrop-filter: blur(10px);
    border-top: 1px solid var(--pb-line);
    box-shadow: 0 -2px 12px rgba(16, 24, 40, 0.06);
    padding: 10px 14px;
    padding-bottom: max(10px, env(safe-area-inset-bottom));
  }
  .proceed-btn { padding: 13px 18px; font-size: 15px; }
  .preview-toggle-btn { padding: 13px 16px; font-size: 14px; }
  .min-photos-warning { text-align: center; }

  .pages-main { padding: 0; gap: 10px; }
  .pages-toolbar { padding: 6px; gap: 4px; flex-wrap: nowrap; overflow-x: auto; }
  .toolbar-action { flex: 0 0 auto; padding: 10px 12px; white-space: nowrap; }
  .toolbar-action.danger { margin-left: 0; }
  .pages-thumbnails { padding: 10px; }
}

@media (max-width: 600px) {
  .designer-container { padding: 8px; }
  .stat-value { font-size: 18px; }
  .designer-product-info { padding: 12px 14px; min-width: 0; }
  .designer-product-info h2 { font-size: 14px; }
  .designer-product-price { font-size: 20px; }
}

/* ───────── Cover customization: button + slide-over (desktop) ───────── */
.cover-panel-open-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 13px 18px;
  background: var(--pb-accent);
  color: #fff;
  border: none;
  border-radius: var(--pb-radius-sm);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, box-shadow 0.15s;
}
.cover-panel-open-btn:hover {
  background: #111827;
  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.18);
}

.cover-slideover {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 360px;
  max-width: 92vw;
  z-index: 1100;
  display: flex;
  flex-direction: column;
  background: var(--pb-surface, #fff);
  border-right: 1px solid #e6e8ec;
  box-shadow: 8px 0 32px rgba(16, 24, 40, 0.14);
  transform: translateX(-102%);
  visibility: hidden;
  transition: transform 0.25s ease, visibility 0s linear 0.25s;
}
.cover-slideover.open {
  transform: translateX(0);
  visibility: visible;
  transition: transform 0.25s ease, visibility 0s;
}
.cover-slideover-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e6e8ec;
  flex-shrink: 0;
}
.cover-slideover-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
}
.cover-slideover-close {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: #f3f4f6;
  color: #1f2937;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.cover-slideover-close:hover { background: #e5e7eb; }
.cover-slideover-body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  overflow: hidden;
}

/* Controls inside slide-over: horizontal tabs on top, one scrollable body */
.cover-slideover .cover-controls-panel {
  width: 100%;
  max-height: none;
  flex-direction: column;
  height: 100%;
}
.cover-slideover .cover-rail {
  flex-direction: row;
  width: auto;
  gap: 4px;
  padding: 12px 20px 0;
  background: none;
  border-right: none;
  border-bottom: 1px solid #e6e8ec;
}
.cover-slideover .cover-rail-btn {
  flex-direction: row;
  gap: 8px;
  flex: 1 1;
  justify-content: center;
  padding: 10px 6px;
  border-radius: 8px 8px 0 0;
  background: none;
  color: #6b7280;
  border-bottom: 2px solid transparent;
}
.cover-slideover .cover-rail-btn:hover { background: #f3f4f6; }
.cover-slideover .cover-rail-btn.active {
  background: none;
  color: #1f2937;
  border-bottom-color: #1f2937;
}
.cover-slideover .cover-rail-icon { font-size: 13px; opacity: 0.8; }
.cover-slideover .cover-rail-label { font-size: 12px; font-weight: 600; }
.cover-slideover .cover-panel-body {
  max-height: none;
  padding: 20px;
  gap: 16px;
}

/* Quieter form controls (apply in drawer + slide-over) */
.cover-field { gap: 6px; }
.cover-field label {
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
}
.cover-field input[type="text"],
.cover-field select {
  border-color: #d3d7de;
  border-radius: 8px;
  padding: 9px 11px;
}
.cover-field input[type="text"]:focus,
.cover-field select:focus {
  border-color: #4f6bed;
  box-shadow: 0 0 0 3px rgba(79, 107, 237, 0.14);
}
.cover-color-row {
  padding: 6px;
  border: 1px solid #e6e8ec;
  border-radius: 8px;
  background: #fafbfc;
}
.cover-color-row input[type="color"] {
  width: 30px;
  height: 30px;
  border: 1px solid #d3d7de;
  border-radius: 6px;
}
.cover-color-hex {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
}
.cover-mode-btn,
.cover-side-tab,
.cover-layout-btn { border-color: #d3d7de; border-radius: 8px; }
.cover-mode-btn.active,
.cover-side-tab.active,
.cover-layout-btn.active { border-color: #1f2937; box-shadow: 0 0 0 1px #1f2937 inset; }
.cover-layout-btn:hover { background: #f3f4f6; }
.cover-sticker-cat.active { background: #1f2937; border-color: #1f2937; }
.cover-sticker-thumb { border-radius: 8px; border-color: #e6e8ec; }
.cover-sticker-thumb:hover { border-color: #1f2937; background: #f3f4f6; }

/* ───────── Cover view: fit cover + page strip on one screen (desktop) ─────────
   Budget (px): site header ≈150, container padding 40, strip ≈180, gaps/
   external bar/stage padding ≈80. The cover height is whatever is left, so
   the thumbnail strip below is always visible without scrolling. */
@media (min-width: 1101px) {
  .cover-page.large {
    height: clamp(260px, calc(100vh - 450px), 640px);
  }
  .cover-preview-stage { padding: 8px 12px; gap: 8px; }
  .pages-manager.cover-active .pages-main { gap: 10px; }
}

/* ───────── Pages view: spread + toolbar + thumbnails on one screen (desktop) ─────────
   Same budget idea as the cover view: the spread is sized from the viewport
   height (page ratio 210:297, two pages side by side → width = height × 1.414)
   so the toolbar and page strip below it never fall off-screen. */
@media (min-width: 1101px) {
  .current-page-container {
    min-height: 0;
    max-height: calc(100vh - 470px);
    padding: 24px;
  }
  .page-spread {
    max-width: min(640px, max(380px, calc((100vh - 540px) * 1.414)));
  }
  .pages-main { gap: 12px; }
  .pages-toolbar { padding: 6px; }
  .toolbar-action { padding: 8px 14px; }
  .pages-thumbnails { padding: 12px; }
}

/* Tips are secondary — only show them when the screen is tall enough */
@media (min-width: 1101px) and (max-height: 900px) {
  .help-info { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/PhotoBook/PhotoBookTheme.css"],"names":[],"mappings":"AAAA;;;;iCAIiC;;AAEjC;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;EAC7C,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,6BAA6B,oBAAoB,EAAE;AACnD;;;EAGE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC,sBAAsB,SAAS,EAAE;;AAEjC,oBAAoB,SAAS,EAAE,YAAY,EAAE;;AAE7C;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA,gBAAgB,qCAAqC,EAAE;AACvD;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,QAAQ;AACV;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA,+BAA+B,aAAa,EAAE;;AAE9C;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,gBAAgB,kBAAkB,EAAE,yBAAyB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAClG,gBAAgB,kBAAkB,EAAE;;AAEpC,kCAAkC;AAClC;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA,yBAAyB,UAAU,EAAE,SAAS,EAAE;;AAEhD,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;AACA,wBAAwB,eAAe,EAAE,iCAAiC,EAAE;AAC5E;EACE,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA,kBAAkB;AAClB;EACE,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;;EAGE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA,kBAAkB,4BAA4B,EAAE;AAChD,wBAAwB,mBAAmB,EAAE,gBAAgB,EAAE;AAC/D;EACE,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA,2BAA2B,oBAAoB,EAAE,gBAAgB,EAAE;;AAEnE;EACE,QAAQ;EACR,YAAY;AACd;AACA,iBAAiB,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC5E;EACE,QAAQ;EACR,UAAU;EACV,iCAAiC;EACjC,0BAA0B;AAC5B;AACA,8BAA8B,4BAA4B,EAAE;;AAE5D;EACE;IACE,6BAA6B;IAC7B,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;IACb,qEAAqE;IACrE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,UAAU;EACV,SAAS;AACX;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA,eAAe,8CAA8C,EAAE;AAC/D,eAAe,6CAA6C,EAAE;;AAE9D,0EAA0E;AAC1E;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,iCAAiC;AACnC;AACA,oBAAoB,0BAA0B,EAAE,QAAQ,EAAE;AAC1D,aAAa,YAAY,EAAE;AAC3B,aAAa,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAE5E;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,QAAQ;EACR,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA,wBAAwB,mBAAmB,EAAE,yBAAyB,EAAE;AACxE,yBAAyB,uBAAuB,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;AAChG,+BAA+B,mBAAmB,EAAE,yBAAyB,EAAE;;AAE/E,kDAAkD;AAClD;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,SAAS;AACX;AACA,6CAA6C,mBAAmB,EAAE;AAClE,6CAA6C,mBAAmB,EAAE;AAClE,mDAAmD,+BAA+B,EAAE;AACpF,wBAAwB,eAAe,EAAE;AACzC;EACE,gBAAgB;EAChB,sEAAsE;AACxE;AACA,kBAAkB,mBAAmB,EAAE;AACvC,mBAAmB,0BAA0B,EAAE,eAAe,EAAE,eAAe,EAAE;AACjF;;EAEE,gCAAgC;EAChC,mBAAmB;AACrB;AACA,0CAA0C,oBAAoB,EAAE,gBAAgB,EAAE;AAClF;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;AACA,4BAA4B,mBAAmB,EAAE,iCAAiC,EAAE;AACpF,2BAA2B,0BAA0B,EAAE,gBAAgB,EAAE;;AAEzE,kBAAkB;AAClB;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA,iBAAiB,mBAAmB,EAAE,gCAAgC,EAAE,kCAAkC,EAAE;AAC5G,uBAAuB,mBAAmB,EAAE,mCAAmC,EAAE;AACjF,wBAAwB,yBAAyB,EAAE,2BAA2B,EAAE;;AAEhF,eAAe;AACf,uBAAuB,yBAAyB,EAAE,kCAAkC,EAAE,gBAAgB,EAAE;AACxG,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE;AACrE,wBAAwB,mBAAmB,EAAE;AAC7C,8BAA8B,mBAAmB,EAAE;;AAEnD,wCAAwC;AACxC;EACE,sBAAsB,QAAQ,EAAE,aAAa,EAAE;EAC/C,oBAAoB,WAAW,EAAE;;EAEjC;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,uCAAuC;IACvC,oBAAoB;IACpB,iBAAiB;IACjB,6CAA6C;EAC/C;EACA,uBAAuB,eAAe,EAAE;EACxC,uBAAuB,eAAe,EAAE,gBAAgB,EAAE;;EAE1D,iBAAiB,wBAAwB,EAAE;EAC3C;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,uCAAuC;IACvC,mBAAmB;EACrB;EACA,2BAA2B,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;EAC/E,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;EACrF;IACE,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,YAAY;EACd;EACA,sBAAsB,aAAa,EAAE,SAAS,EAAE;EAChD;IACE,6BAA6B;IAC7B,gCAAgC;IAChC,+BAA+B;IAC/B,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE,qCAAqC;IACrC,2BAA2B;IAC3B,oCAAoC;IACpC,8CAA8C;IAC9C,kBAAkB;IAClB,sDAAsD;EACxD;EACA,eAAe,kBAAkB,EAAE,eAAe,EAAE;EACpD,sBAAsB,kBAAkB,EAAE,eAAe,EAAE;EAC3D,sBAAsB,kBAAkB,EAAE;;EAE1C,cAAc,UAAU,EAAE,SAAS,EAAE;EACrC,iBAAiB,YAAY,EAAE,QAAQ,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;EAC9E,kBAAkB,cAAc,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;EAC3E,yBAAyB,cAAc,EAAE;EACzC,oBAAoB,aAAa,EAAE;AACrC;;AAEA;EACE,sBAAsB,YAAY,EAAE;EACpC,cAAc,eAAe,EAAE;EAC/B,yBAAyB,kBAAkB,EAAE,YAAY,EAAE;EAC3D,4BAA4B,eAAe,EAAE;EAC7C,0BAA0B,eAAe,EAAE;AAC7C;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,YAAY;EACZ,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,+BAA+B;EAC/B,6CAA6C;EAC7C,4BAA4B;EAC5B,kBAAkB;EAClB,4DAA4D;AAC9D;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA,+BAA+B,mBAAmB,EAAE;AACpD;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;AACA,yCAAyC,mBAAmB,EAAE;AAC9D;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;AACA,oCAAoC,eAAe,EAAE,YAAY,EAAE;AACnE,qCAAqC,eAAe,EAAE,gBAAgB,EAAE;AACxE;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA,yDAAyD;AACzD,eAAe,QAAQ,EAAE;AACzB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,2DAA2D;EAC3D,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;AACA;;oBAEoB,qBAAqB,EAAE,kBAAkB,EAAE;AAC/D;;2BAE2B,qBAAqB,EAAE,mCAAmC,EAAE;AACvF,0BAA0B,mBAAmB,EAAE;AAC/C,4BAA4B,mBAAmB,EAAE,qBAAqB,EAAE;AACxE,uBAAuB,kBAAkB,EAAE,qBAAqB,EAAE;AAClE,6BAA6B,qBAAqB,EAAE,mBAAmB,EAAE;;AAEzE;;;mEAGmE;AACnE;EACE;IACE,gDAAgD;EAClD;EACA,uBAAuB,iBAAiB,EAAE,QAAQ,EAAE;EACpD,0CAA0C,SAAS,EAAE;AACvD;;AAEA;;;kEAGkE;AAClE;EACE;IACE,aAAa;IACb,+BAA+B;IAC/B,aAAa;EACf;EACA;IACE,gEAAgE;EAClE;EACA,cAAc,SAAS,EAAE;EACzB,iBAAiB,YAAY,EAAE;EAC/B,kBAAkB,iBAAiB,EAAE;EACrC,oBAAoB,aAAa,EAAE;AACrC;;AAEA,uEAAuE;AACvE;EACE,aAAa,aAAa,EAAE;AAC9B","sourcesContent":["/* PhotoBook designer — calm, light visual layer.\n   Loaded AFTER PhotoBookDesigner.css / PagesManager.css so it only restyles\n   (colours, spacing, radii, typography). Layout/behaviour rules there are\n   untouched; anything that would clash with their mobile-drawer rules is\n   scoped to min-width: 1101px. */\n\n.photobook-designer {\n  --pb-bg: #f6f7f9;\n  --pb-surface: #ffffff;\n  --pb-line: #e6e8ec;\n  --pb-line-strong: #d3d7de;\n  --pb-ink: #1f2937;\n  --pb-ink-soft: #6b7280;\n  --pb-ink-faint: #9aa1ad;\n  --pb-accent: #1f2937;\n  --pb-focus: #4f6bed;\n  --pb-danger: #c0392b;\n  --pb-radius: 12px;\n  --pb-radius-sm: 8px;\n  --pb-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);\n  background: var(--pb-bg);\n  color: var(--pb-ink);\n}\n\n.photobook-designer button { font-family: inherit; }\n.photobook-designer button:focus-visible,\n.photobook-designer input:focus-visible,\n.photobook-designer select:focus-visible {\n  outline: 2px solid var(--pb-focus);\n  outline-offset: 2px;\n}\n\n/* ───────── Sidebar (left) ───────── */\n.designer-container { gap: 24px; }\n\n.designer-sidebar { gap: 14px; width: 260px; }\n\n.designer-product-info {\n  background: var(--pb-surface);\n  color: var(--pb-ink);\n  border: 1px solid var(--pb-line);\n  border-radius: var(--pb-radius);\n  box-shadow: var(--pb-shadow);\n  padding: 18px 20px;\n  text-align: left;\n}\n.designer-product-info h2 {\n  margin: 0 0 6px;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--pb-ink);\n}\n.designer-product-price {\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: var(--pb-ink);\n}\n\n/* Page limits + counters → one quiet card */\n.page-info-box {\n  background: var(--pb-surface);\n  border: 1px solid var(--pb-line);\n  border-radius: var(--pb-radius);\n  box-shadow: var(--pb-shadow);\n  padding: 14px 16px 12px;\n  align-items: flex-start;\n  text-align: left;\n}\n.page-info-box h4 {\n  margin: 0 0 6px;\n  color: var(--pb-ink-faint);\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n.page-info-box p {\n  margin: 2px 0;\n  color: var(--pb-ink-soft);\n  font-size: 13px;\n}\n.page-info-box .max-pages {\n  color: var(--pb-ink);\n  font-weight: 500;\n}\n\n.design-stats {\n  gap: 0;\n  background: var(--pb-surface);\n  border: 1px solid var(--pb-line);\n  border-radius: var(--pb-radius);\n  box-shadow: var(--pb-shadow);\n  overflow: hidden;\n}\n.stat {\n  background: none;\n  border-radius: 0;\n  padding: 12px 6px;\n  min-width: 0;\n}\n.stat + .stat { border-left: 1px solid var(--pb-line); }\n.stat-value {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--pb-ink);\n  letter-spacing: -0.02em;\n}\n.stat-label {\n  font-size: 10px;\n  color: var(--pb-ink-faint);\n  letter-spacing: 0.04em;\n  margin-top: 3px;\n  line-height: 1.25;\n}\n\n/* Actions */\n.export-section {\n  background: none;\n  border: none;\n  padding: 0;\n  gap: 8px;\n}\n.proceed-btn,\n.preview-toggle-btn {\n  padding: 12px 18px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: var(--pb-radius-sm);\n  letter-spacing: 0;\n}\n.proceed-btn {\n  background: var(--pb-accent);\n  color: #fff;\n  box-shadow: none;\n}\n.proceed-btn:hover:not(:disabled) {\n  transform: none;\n  background: #111827;\n  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.18);\n}\n.proceed-btn:disabled {\n  background: #cfd4dc;\n  color: #fff;\n  opacity: 1;\n}\n.preview-toggle-btn {\n  background: var(--pb-surface);\n  color: var(--pb-ink);\n  border: 1px solid var(--pb-line-strong);\n}\n.preview-toggle-btn:hover:not(:disabled) {\n  background: #f3f4f6;\n  color: var(--pb-ink);\n}\n.preview-toggle-btn:disabled { opacity: 0.55; }\n\n.min-photos-warning {\n  background: none;\n  border: none;\n  color: var(--pb-ink-soft);\n  font-size: 12px;\n  padding: 0 2px;\n  margin: 2px 0 0;\n  text-align: left;\n}\n\n.help-info {\n  background: none;\n  border: none;\n  border-top: 1px solid var(--pb-line);\n  border-radius: 0;\n  padding: 14px 2px 0;\n}\n.help-info h4 {\n  color: var(--pb-ink-faint);\n  margin: 0 0 8px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n.help-info ul { padding-left: 16px; color: var(--pb-ink-soft); font-size: 12px; line-height: 1.6; }\n.help-info li { margin-bottom: 3px; }\n\n/* ───────── Workspace ───────── */\n.pages-manager {\n  background: transparent;\n  gap: 20px;\n  max-height: none;\n}\n\n.pages-secondary-panel { padding: 0; gap: 12px; }\n\n/* Background colours */\n.page-bg-colors {\n  background: var(--pb-surface);\n  border: 1px solid var(--pb-line);\n  border-radius: var(--pb-radius);\n  box-shadow: var(--pb-shadow);\n  padding: 10px 14px;\n  gap: 8px;\n}\n.page-bg-colors span {\n  color: var(--pb-ink-soft);\n  font-size: 12px;\n  font-weight: 500;\n  margin-right: auto;\n}\n.page-color-btn {\n  width: 22px;\n  height: 22px;\n  border: 1px solid var(--pb-line-strong);\n}\n.page-color-btn:hover { transform: none; border-color: var(--pb-ink-faint); }\n.page-color-btn.active {\n  border-color: var(--pb-ink);\n  box-shadow: 0 0 0 2px #fff, 0 0 0 3px var(--pb-ink);\n}\n\n/* Photo library */\n.library-header {\n  gap: 8px;\n  margin-bottom: 14px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--pb-line);\n}\n.library-header h4 {\n  color: var(--pb-ink);\n  font-size: 13px;\n  font-weight: 600;\n}\n.photo-count-badge {\n  background: #eef0f4;\n  color: var(--pb-ink-soft);\n  font-weight: 600;\n}\n.add-photos-btn,\n.add-photos-phone-btn,\n.ai-generate-btn {\n  padding: 10px 14px;\n  border-radius: var(--pb-radius-sm);\n  font-size: 13px;\n  font-weight: 600;\n  box-shadow: none;\n}\n.add-photos-btn { background: var(--pb-accent); }\n.add-photos-btn:hover { background: #111827; box-shadow: none; }\n.add-photos-phone-btn {\n  color: var(--pb-ink);\n  border: 1px solid var(--pb-line-strong);\n}\n.add-photos-phone-btn:hover:not(:disabled) {\n  background: #f3f4f6;\n  border-color: var(--pb-line-strong);\n}\n.ai-generate-btn {\n  background: #eef1ff;\n  color: #3b4bb8;\n  border: 1px solid #d9defa;\n}\n.ai-generate-btn:hover:not(:disabled) {\n  transform: none;\n  box-shadow: none;\n  background: #e4e9ff;\n}\n.mesazhi-per-foto {\n  margin: 2px 0 0;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--pb-ink-soft);\n}\n.mesazhi-per-foto strong { color: var(--pb-ink); font-weight: 600; }\n\n.library-photos {\n  gap: 8px;\n  padding: 2px;\n}\n.library-photo { border-radius: 6px; overflow: hidden; background: #eef0f4; }\n.library-photo-delete {\n  top: 4px;\n  right: 4px;\n  background: rgba(17, 24, 39, 0.6);\n  backdrop-filter: blur(4px);\n}\n.library-photo-delete:hover { background: var(--pb-danger); }\n\n@media (min-width: 1101px) {\n  .photo-library {\n    background: var(--pb-surface);\n    border: 1px solid var(--pb-line);\n    border-radius: var(--pb-radius);\n    box-shadow: var(--pb-shadow);\n    padding: 16px;\n    /* stop it stretching to the full row height when it has few photos */\n    height: auto;\n    max-height: 70vh;\n  }\n}\n\n/* Canvas area */\n.pages-main {\n  background: transparent;\n  padding: 0;\n  gap: 14px;\n}\n.current-page-container {\n  background: var(--pb-surface);\n  border: 1px solid var(--pb-line);\n  border-radius: var(--pb-radius);\n  box-shadow: var(--pb-shadow);\n}\n.page-spread { box-shadow: 0 10px 30px rgba(16, 24, 40, 0.14); }\n.page-editor { box-shadow: 0 6px 22px rgba(16, 24, 40, 0.12); }\n\n/* Empty photo slot — quiet outline with a \"+\" instead of a camera emoji */\n.photo-slot {\n  background: #f4f5f8;\n  border: 1.5px dashed var(--pb-line-strong);\n  border-radius: 3px;\n}\n.photo-slot:not(.has-image):hover,\n.photo-slot.drag-over {\n  background: #eceef3;\n  border-color: var(--pb-ink-faint);\n}\n.slot-placeholder { color: var(--pb-ink-faint); gap: 4px; }\n.slot-icon { opacity: 0.9; }\n.slot-text { font-size: 11px; font-weight: 500; color: var(--pb-ink-faint); }\n\n.page-dimensions {\n  background: rgba(17, 24, 39, 0.55);\n  font-weight: 500;\n  font-size: 10px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  backdrop-filter: blur(4px);\n}\n\n/* Toolbar */\n.pages-toolbar {\n  background: var(--pb-surface);\n  border: 1px solid var(--pb-line);\n  border-radius: var(--pb-radius);\n  box-shadow: var(--pb-shadow);\n  padding: 8px;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.toolbar-action {\n  background: transparent;\n  border: 1px solid transparent;\n  color: var(--pb-ink);\n  padding: 9px 14px;\n  border-radius: var(--pb-radius-sm);\n  font-size: 13px;\n  font-weight: 500;\n}\n.toolbar-action:hover { background: #f3f4f6; border-color: transparent; }\n.toolbar-action.danger { color: var(--pb-danger); border-color: transparent; margin-left: auto; }\n.toolbar-action.danger:hover { background: #fdf0ee; border-color: transparent; }\n\n/* Thumbnail strip — light, not a heavy dark bar */\n.pages-thumbnails {\n  background: var(--pb-surface);\n  border: 1px solid var(--pb-line);\n  border-radius: var(--pb-radius);\n  box-shadow: var(--pb-shadow);\n  padding: 14px;\n  gap: 12px;\n}\n.pages-thumbnails::-webkit-scrollbar-track { background: #f3f4f6; }\n.pages-thumbnails::-webkit-scrollbar-thumb { background: #cfd4dc; }\n.pages-thumbnails::-webkit-scrollbar-thumb:hover { background: var(--pb-ink-faint); }\n.page-thumbnail:hover { transform: none; }\n.thumbnail-preview {\n  background: #fff;\n  box-shadow: 0 0 0 1px var(--pb-line), 0 1px 3px rgba(16, 24, 40, 0.08);\n}\n.thumbnail-slot { background: #dfe2e8; }\n.thumbnail-label { color: var(--pb-ink-faint); font-size: 11px; margin-top: 6px; }\n.page-thumbnail.active .thumbnail-preview,\n.page-thumbnail.active .thumbnail-preview.cover-thumbnail-preview {\n  outline: 2px solid var(--pb-ink);\n  outline-offset: 2px;\n}\n.page-thumbnail.active .thumbnail-label { color: var(--pb-ink); font-weight: 600; }\n.add-page-thumbnail {\n  background: #fafbfc;\n  border: 1.5px dashed var(--pb-line-strong);\n}\n.add-page-thumbnail:hover { background: #f3f4f6; border-color: var(--pb-ink-faint); }\n.add-page-thumbnail span { color: var(--pb-ink-faint); font-weight: 300; }\n\n/* Layout picker */\n.layout-picker {\n  border: 1px solid var(--pb-line);\n  border-radius: var(--pb-radius);\n  box-shadow: var(--pb-shadow);\n}\n.layout-option { background: #fafbfc; border: 1px solid var(--pb-line); border-radius: var(--pb-radius-sm); }\n.layout-option:hover { background: #f3f4f6; border-color: var(--pb-line-strong); }\n.layout-option.active { background: var(--pb-ink); border-color: var(--pb-ink); }\n\n/* Text panel */\n.text-panel-vertical { background: var(--pb-ink); border-radius: var(--pb-radius-sm); box-shadow: none; }\n.text-panel-btn.active { background: #4f6bed; border-color: #4f6bed; }\n.text-panel-btn-apply { background: #3b4bb8; }\n.text-panel-btn-apply:hover { background: #2f3d99; }\n\n/* ───────── Tablet / mobile ───────── */\n@media (max-width: 1100px) {\n  .designer-container { gap: 8px; padding: 10px; }\n  .designer-sidebar { width: auto; }\n\n  .drawer-toggle-tab {\n    background: var(--pb-surface);\n    color: var(--pb-ink);\n    border: 1px solid var(--pb-line-strong);\n    border-radius: 999px;\n    padding: 8px 14px;\n    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.12);\n  }\n  .drawer-toggle-arrow { font-size: 14px; }\n  .drawer-toggle-label { font-size: 12px; font-weight: 600; }\n\n  .mobile-drawer { background: var(--pb-bg); }\n  .mobile-drawer-header {\n    background: var(--pb-surface);\n    color: var(--pb-ink);\n    border-bottom: 1px solid var(--pb-line);\n    align-items: center;\n  }\n  .mobile-drawer-header h3 { font-size: 15px; font-weight: 600; margin: 0 0 2px; }\n  .mobile-drawer-price { font-size: 16px; font-weight: 600; color: var(--pb-ink-soft); }\n  .mobile-drawer-close {\n    background: #f3f4f6;\n    color: var(--pb-ink);\n    width: 36px;\n    height: 36px;\n  }\n  .mobile-drawer-body { padding: 14px; gap: 12px; }\n  .mobile-drawer-body .photo-library {\n    background: var(--pb-surface);\n    border: 1px solid var(--pb-line);\n    border-radius: var(--pb-radius);\n    padding: 14px;\n  }\n\n  /* bottom action bar */\n  .export-section {\n    background: rgba(255, 255, 255, 0.96);\n    backdrop-filter: blur(10px);\n    border-top: 1px solid var(--pb-line);\n    box-shadow: 0 -2px 12px rgba(16, 24, 40, 0.06);\n    padding: 10px 14px;\n    padding-bottom: max(10px, env(safe-area-inset-bottom));\n  }\n  .proceed-btn { padding: 13px 18px; font-size: 15px; }\n  .preview-toggle-btn { padding: 13px 16px; font-size: 14px; }\n  .min-photos-warning { text-align: center; }\n\n  .pages-main { padding: 0; gap: 10px; }\n  .pages-toolbar { padding: 6px; gap: 4px; flex-wrap: nowrap; overflow-x: auto; }\n  .toolbar-action { flex: 0 0 auto; padding: 10px 12px; white-space: nowrap; }\n  .toolbar-action.danger { margin-left: 0; }\n  .pages-thumbnails { padding: 10px; }\n}\n\n@media (max-width: 600px) {\n  .designer-container { padding: 8px; }\n  .stat-value { font-size: 18px; }\n  .designer-product-info { padding: 12px 14px; min-width: 0; }\n  .designer-product-info h2 { font-size: 14px; }\n  .designer-product-price { font-size: 20px; }\n}\n\n/* ───────── Cover customization: button + slide-over (desktop) ───────── */\n.cover-panel-open-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  padding: 13px 18px;\n  background: var(--pb-accent);\n  color: #fff;\n  border: none;\n  border-radius: var(--pb-radius-sm);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, box-shadow 0.15s;\n}\n.cover-panel-open-btn:hover {\n  background: #111827;\n  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.18);\n}\n\n.cover-slideover {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 360px;\n  max-width: 92vw;\n  z-index: 1100;\n  display: flex;\n  flex-direction: column;\n  background: var(--pb-surface, #fff);\n  border-right: 1px solid #e6e8ec;\n  box-shadow: 8px 0 32px rgba(16, 24, 40, 0.14);\n  transform: translateX(-102%);\n  visibility: hidden;\n  transition: transform 0.25s ease, visibility 0s linear 0.25s;\n}\n.cover-slideover.open {\n  transform: translateX(0);\n  visibility: visible;\n  transition: transform 0.25s ease, visibility 0s;\n}\n.cover-slideover-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e6e8ec;\n  flex-shrink: 0;\n}\n.cover-slideover-header h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1f2937;\n}\n.cover-slideover-close {\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 50%;\n  background: #f3f4f6;\n  color: #1f2937;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n.cover-slideover-close:hover { background: #e5e7eb; }\n.cover-slideover-body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  overflow: hidden;\n}\n\n/* Controls inside slide-over: horizontal tabs on top, one scrollable body */\n.cover-slideover .cover-controls-panel {\n  width: 100%;\n  max-height: none;\n  flex-direction: column;\n  height: 100%;\n}\n.cover-slideover .cover-rail {\n  flex-direction: row;\n  width: auto;\n  gap: 4px;\n  padding: 12px 20px 0;\n  background: none;\n  border-right: none;\n  border-bottom: 1px solid #e6e8ec;\n}\n.cover-slideover .cover-rail-btn {\n  flex-direction: row;\n  gap: 8px;\n  flex: 1;\n  justify-content: center;\n  padding: 10px 6px;\n  border-radius: 8px 8px 0 0;\n  background: none;\n  color: #6b7280;\n  border-bottom: 2px solid transparent;\n}\n.cover-slideover .cover-rail-btn:hover { background: #f3f4f6; }\n.cover-slideover .cover-rail-btn.active {\n  background: none;\n  color: #1f2937;\n  border-bottom-color: #1f2937;\n}\n.cover-slideover .cover-rail-icon { font-size: 13px; opacity: 0.8; }\n.cover-slideover .cover-rail-label { font-size: 12px; font-weight: 600; }\n.cover-slideover .cover-panel-body {\n  max-height: none;\n  padding: 20px;\n  gap: 16px;\n}\n\n/* Quieter form controls (apply in drawer + slide-over) */\n.cover-field { gap: 6px; }\n.cover-field label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #4b5563;\n}\n.cover-field input[type=\"text\"],\n.cover-field select {\n  border-color: #d3d7de;\n  border-radius: 8px;\n  padding: 9px 11px;\n}\n.cover-field input[type=\"text\"]:focus,\n.cover-field select:focus {\n  border-color: #4f6bed;\n  box-shadow: 0 0 0 3px rgba(79, 107, 237, 0.14);\n}\n.cover-color-row {\n  padding: 6px;\n  border: 1px solid #e6e8ec;\n  border-radius: 8px;\n  background: #fafbfc;\n}\n.cover-color-row input[type=\"color\"] {\n  width: 30px;\n  height: 30px;\n  border: 1px solid #d3d7de;\n  border-radius: 6px;\n}\n.cover-color-hex {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12px;\n  color: #6b7280;\n  text-transform: uppercase;\n}\n.cover-mode-btn,\n.cover-side-tab,\n.cover-layout-btn { border-color: #d3d7de; border-radius: 8px; }\n.cover-mode-btn.active,\n.cover-side-tab.active,\n.cover-layout-btn.active { border-color: #1f2937; box-shadow: 0 0 0 1px #1f2937 inset; }\n.cover-layout-btn:hover { background: #f3f4f6; }\n.cover-sticker-cat.active { background: #1f2937; border-color: #1f2937; }\n.cover-sticker-thumb { border-radius: 8px; border-color: #e6e8ec; }\n.cover-sticker-thumb:hover { border-color: #1f2937; background: #f3f4f6; }\n\n/* ───────── Cover view: fit cover + page strip on one screen (desktop) ─────────\n   Budget (px): site header ≈150, container padding 40, strip ≈180, gaps/\n   external bar/stage padding ≈80. The cover height is whatever is left, so\n   the thumbnail strip below is always visible without scrolling. */\n@media (min-width: 1101px) {\n  .cover-page.large {\n    height: clamp(260px, calc(100vh - 450px), 640px);\n  }\n  .cover-preview-stage { padding: 8px 12px; gap: 8px; }\n  .pages-manager.cover-active .pages-main { gap: 10px; }\n}\n\n/* ───────── Pages view: spread + toolbar + thumbnails on one screen (desktop) ─────────\n   Same budget idea as the cover view: the spread is sized from the viewport\n   height (page ratio 210:297, two pages side by side → width = height × 1.414)\n   so the toolbar and page strip below it never fall off-screen. */\n@media (min-width: 1101px) {\n  .current-page-container {\n    min-height: 0;\n    max-height: calc(100vh - 470px);\n    padding: 24px;\n  }\n  .page-spread {\n    max-width: min(640px, max(380px, calc((100vh - 540px) * 1.414)));\n  }\n  .pages-main { gap: 12px; }\n  .pages-toolbar { padding: 6px; }\n  .toolbar-action { padding: 8px 14px; }\n  .pages-thumbnails { padding: 12px; }\n}\n\n/* Tips are secondary — only show them when the screen is tall enough */\n@media (min-width: 1101px) and (max-height: 900px) {\n  .help-info { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
